// extracted by mini-css-extract-plugin
export default {"color":"#ff5c00"};